module Meevo.Components.Common {

    export class RecentService {

        private mvo2RecentMap: any = null;
        private recentMap: any = null;
        private entityVersion: any = {};
        private recentFromServer: any = {};
        private fetchedFromServer: any = {};
        private hadRecentInLocal: any = {};
        maxRecentClient: number;

        private Meevo2RecentKey: string = 'meevo2.recent';

        constructor(private $q: ng.IQService,
            private $rootScope: ng.IRootScopeService,
            private dataService: Meevo.Components.BaseClasses.IDataService,
            private identityService: Meevo.Components.Common.IIdentityService) {

            this.dataService.customMethodData(`/${Meevo.AppSettings.Default.API_ROOT}/Settings/General`, 'GET', null)
                .then(res => {
                    this.maxRecentClient = res.data.maximumRecentClient > 0 ? res.data.maximumRecentClient : 10;
                });

        }

        public addRecent(item: any, key: string, broadcast: boolean = true) {
            // If the item has no id, it isn't valid to include as a recent item.
            if (_.isEmpty(item.id)) {
                return;
            }
            if (_.isEmpty(item.displayName)) {
                item.displayName = item.lastName + ', ' + item.firstName;
            }

            this.addItem(key, item);
        }

        public deleteRecent(itemId: any, key: string, broadcast: boolean = true) {
            // If the itemId is empty/null, it isn't valid to include as a recent item.
            if (_.isEmpty(itemId)) {
                return;
            }

            this.deleteItem(key, itemId);
        }

        private addItem(key: string, value: any) {
            var list = this.getKeyObject(key);

            // ensure it's unique
            var index = list.findIndex(item => item.id === value.id);
            if (index >= 0)
                list.splice(index, 1);

            // ensure list maintains max number of items
            if (list.length === this.maxRecentClient) {
                list.splice(this.maxRecentClient - 1, 1);
            }

            // then add to the top
            list.unshift(value);

            // save
            this.setKeyObject(key, value);
        }

        private deleteItem(key: string, value: any) {
            var list = this.getKeyObject(key);

            // find value in list
            var index = list.findIndex(item => item.id === value);
            if (index >= 0) {
                // remove from list if found
                list.splice(index, 1);
            }

            // save
            this.setKeyObject(key);
        }

        private getKeyObject(key: any): any {
            var userId = this.getUserId();
            var userName = this.identityService.current().userName;

            if (!this.mvo2RecentMap) {
                if (localStorage) {

                    var mv2RecentStr = localStorage[this.Meevo2RecentKey];
                    if (!mv2RecentStr) {
                        mv2RecentStr = localStorage[this.Meevo2RecentKey] = "{}";
                    }

                    this.mvo2RecentMap = JSON.parse(mv2RecentStr);
                    this.recentMap = this.mvo2RecentMap[userId];
                    if (!this.recentMap) {
                        this.recentMap = this.mvo2RecentMap[userName];
                        if (this.recentMap) {
                            // switch from username to userid, to eliminate cross-polination of recent client list between tenants that have the users with same username.
                            this.mvo2RecentMap[userId] = this.recentMap;
                            delete this.mvo2RecentMap[userName];
                            localStorage[this.Meevo2RecentKey] = JSON.stringify(this.mvo2RecentMap);
                            this.hadRecentInLocal[key] = true;
                        }
                    }
                    else {
                        this.hadRecentInLocal[key] = true;
                    }

                }
                else {
                    this.mvo2RecentMap = {};
                }
            }

            if (!this.recentMap) {
                this.recentMap = this.mvo2RecentMap[userId] = {};
            }

            var saveBackToLocalStorage = false;
            if (!this.recentMap[key + "_entityVersion"]) {
                this.recentMap[key + "_entityVersion"] = moment.utc().valueOf();
                saveBackToLocalStorage = true;
            }

            if (!this.recentMap[key]) {
                this.recentMap[key] = [];
                saveBackToLocalStorage = true;
            }

            if (saveBackToLocalStorage) {
                this.hadRecentInLocal[key] = false;
                localStorage[this.Meevo2RecentKey] = JSON.stringify(this.mvo2RecentMap);
            }

            return this.recentMap[key];
        }

        private setKeyObject(key: any, value?: any): any {
            this.recentMap[key + "_entityVersion"] = moment.utc().valueOf();

            if (localStorage) {
                localStorage[this.Meevo2RecentKey] = JSON.stringify(this.mvo2RecentMap);
            }

            this.getRecentsFromServer(key)
                .then(() => {
                    var endPoint: string;
                    var requestData: any = {
                        entityVersion: this.entityVersion[key],
                        itemInfo: null,
                        recentList: null
                    };
                    if (this.entityVersion[key] && value) {
                        requestData.itemInfo = {
                            id: value.id,
                            displayName: value.displayName
                        };
                        endPoint = "Add";
                    }
                    else {
                        requestData.recentList = this.recentMap[key];
                        endPoint = "Replace";
                    }
                    return this.dataService.customMethodData(`api/User/Recents/${key}/${endPoint}`, "POST", requestData)
                        .then((response) => this.updateFromServer(key, response));
                });
        }

        private updateFromServer(key: any, responseFromServer: any) {
            if (responseFromServer && responseFromServer.data) {
                this.recentMap[key + "_entityVersion"] = this.entityVersion[key] = responseFromServer.data.entityVersion;
                this.recentFromServer[key] = responseFromServer.data.recentList;

                if (localStorage) {
                    localStorage[this.Meevo2RecentKey] = JSON.stringify(this.mvo2RecentMap);
                }
            }
        }

        clearRecent(key: any): void {
            var mv2RecentStr = localStorage[this.Meevo2RecentKey];
            var userId = this.getUserId();

            this.mvo2RecentMap = JSON.parse(mv2RecentStr);
            this.recentMap = this.mvo2RecentMap[userId];

            this.recentMap[key] = [];
            this.setKeyObject(key); 
        }

        private getRecentsFromServer(key: any, getFromServer: boolean = false): ng.IPromise<any> {
            var promise: ng.IPromise<any>;
            if (this.entityVersion[key] == null || getFromServer) {
                promise = this.dataService.customMethodData("api/User/Recents/" + key, "GET", { "key": key })
                    .then((response) => {
                        if (response && response.data) {
                            this.entityVersion[key] = response.data.entityVersion;
                            this.recentFromServer[key] = response.data.recentList;

                            var oldEntityVersion = this.recentMap[key + "_entityVersion"];
                            if (!this.entityVersion[key] || (this.entityVersion[key] < oldEntityVersion && this.hadRecentInLocal[key])) { // server has anything older than ours, use local copy
                                this.entityVersion[key] = oldEntityVersion;
                                this.recentFromServer[key] = this.recentMap[key];
                            }
                            else if (this.entityVersion[key]) {
                                // if server copy is newer
                                this.recentMap[key + "_entityVersion"] = this.entityVersion[key];
                                this.recentMap[key] = this.recentFromServer[key];
                            }
                            localStorage[this.Meevo2RecentKey] = JSON.stringify(this.mvo2RecentMap);
                            this.hadRecentInLocal[key] = true;
                        }
                        else {
                            // if no data at server, use local copy
                            this.entityVersion[key] = this.recentMap[key + "_entityVersion"];
                            this.recentFromServer[key] = this.recentMap[key];
                        }
                        this.fetchedFromServer[key] = true;
                        this.setKeyObject(key);

                        return this.recentMap[key];
                    })
                    .catch(() => {
                        // if no data at server, use local copy
                        this.entityVersion[key] = this.recentMap[key + "_entityVersion"];
                        this.recentFromServer[key] = this.recentMap[key];

                        return this.recentMap[key];
                    });
            }
            else {
                promise = this.$q.resolve(this.recentMap[key]);
            }
            return promise;
        }

        private getUserId(): string {
            return this.identityService.current().userId.toString().replaceAll("-", "");
        }

        public getRecentList(key: string): ng.IPromise<any> {
            this.getKeyObject(key); // call to initialize local variables
            return this.getRecentsFromServer(key, true);
        }

        public getRecent(key: string) {
            var list = this.getKeyObject(key);
            return (list.length > 0) ? list[0] : null;
        }

        static factory(): Function {
            let svc = ($q: ng.IQService,
                $rootScope: ng.IRootScopeService,
                dataService: Meevo.Components.BaseClasses.IDataService,
                identityService: Meevo.Components.Common.IIdentityService) => {
                return new RecentService($q, $rootScope, dataService, identityService);
            }

            svc.$inject = ['$q', '$rootScope', 'meevo.components.common.DataService', 'meevo.components.common.IdentityService'];
            return svc;
        }
    }

    angular.module("meevo")
        .factory("meevo.components.common.RecentService", RecentService.factory());
}
